import React, { useMemo } from 'react';
import styled from 'styled-components/macro';
import { find, isEmpty } from 'lodash';
import withBackSupport from 'components/HOCs/withBackSupport';
import { ChannelType } from 'store/pages/loaders/loader-types';
import { useLoadChannels, useLoadInfiniteEpg } from 'hooks/data';

import { useParams } from 'react-router';
import EPGProgramsPage from './EPGPrograms';

const StyledWrapper = styled.div`
  width: 1920px;
  height: 1080px;
  background: ${({ theme }) => theme.epgBackground};
`;

const EPGProgramContainer: React.FC = () => {
  const params = useParams<{ channelId: string }>();
  const channelId = Number(params.channelId);
  const { data: channels, isLoading } = useLoadChannels({ all: true });

  const currentChannel = useMemo(() => {
    return find(channels, { id: channelId }) as ChannelType;
  }, [channelId, channels]);

  const {
    data,
    fetchNextPage,
    fetchPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
  } = useLoadInfiniteEpg(channelId);

  const programs = useMemo(() => {
    const result = [];

    for (const page of data?.pages || []) {
      result.push(...page.data);
    }
    return result;
  }, [data?.pages]);

  if (!currentChannel) return null;

  return (
    <StyledWrapper>
      {!isEmpty(programs) && !isLoading && (
        <EPGProgramsPage
          currentChannel={currentChannel}
          epg={programs}
          fetchNextPage={fetchNextPage}
          fetchPreviousPage={fetchPreviousPage}
          isFetching={isFetchingNextPage || isFetchingPreviousPage}
        />
      )}
    </StyledWrapper>
  );
};

export default withBackSupport(EPGProgramContainer);
